import createTracker from '../../analytics/create-tracker';


const track = createTracker('web', 'syndicated');

/**
 * Catalog of analytics events triggered from Syndication features.
 * Provides a clean interface for describing the tracking events.
 */
export default {
  pocketHitsStandaloneSignupPageView: () => track(null, undefined, 'view'),
  pocketHitsSignupFieldView: () => track('newsletter_email', undefined, 'view'),
  pocketHitsSignupFieldFocus: (formId) => track('newsletter_email_focus', formId, 'click'),
  pocketHitsSignupSubmit: (formId) => track('newsletter_email_submit', formId, 'click'),
  pocketHitsSignupSubmitSuccess: (formId) => track('newsletter_email_success', formId, 'interact'),
  pocketHitsSignupSubmitError: (formId) => track('newsletter_email_error', formId, 'interact'),
  pocketHitsFacebookShareClick: (formId) => track('newsletter_email_facebook', formId, 'interact'),
  pocketHitsTwitterShareClick: (formId) => track('newsletter_email_twitter', formId, 'interact'),
  pocketHitsLinkedInShareClick: (formId) => track('newsletter_email_linkedin', formId, 'interact'),
  pocketHitsEmailConfirmSuccess: (formId) => track('email_confirm', formId, 'view'),
};
